import type { ConceptDef } from '../types';

export const matchNonIdentical: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-non-identical',
  label: 'Match Non-Identical',
  category: 'Matching',
  description: 'See a picture; tap a related (different style) match. Placeholder content.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '🐕 (one dog)', answer: '🐶 dog' },
      { say: '🍏 (green apple)', answer: '🍎 apple' },
      { say: '🚙 (SUV)', answer: '🚗 car' },
      { say: '🌲 (pine)', answer: '🌳 tree' },
      { say: '🐾 (paws)', answer: '🐱 cat' },
    ],
  },
};
